export default __webpack_public_path__ + "static/bounty@2x-af1c2606b0cddb25ddae71628d047c09.png";